/**
 * Table of Contents: collapsible header (mobile), built from the h2 in
 * #post-body, with a scroll-spy active highlight and smooth-scroll on click.
 */
function init($) {
    // ─── Collapsible header (mobile only) ─────────────────────────────────────
    $('[data-toc-toggle]').on('click', function () {
        // On desktop the ToC is always expanded; the header is not a toggle.
        if (!window.matchMedia('(max-width: 767px)').matches) { return; }

        var $btn = $(this);
        var $toc = $btn.closest('[data-toc]');
        var expanded = $btn.attr('aria-expanded') === 'true';

        $toc.toggleClass('blog-toc--collapsed', expanded);
        $btn.attr('aria-expanded', String(!expanded));
    });

    // ─── Build from h2 in #post-body ──────────────────────────────────────────
    var $postBody = $('#post-body');
    var $tocList  = $('#toc-list');
    if (!$postBody.length || !$tocList.length) { return; }

    var headings = $postBody.find('h2').toArray();
    var tocItems = [];

    headings.forEach(function (el, idx) {
        var id = 'toc-heading-' + idx;
        el.id = id;

        var $li   = $('<li>');
        var $link = $('<a>')
            .addClass('blog-post__toc-link')
            .attr('href', '#' + id)
            .text(el.textContent);

        $li.append($link);
        $tocList.append($li);
        tocItems.push({ id: id, el: el, $link: $link });
    });

    // No h2s — hide the ToC header + list; the share row stays visible
    // (it's the only share control on the page). SCSS has display:none rules
    // for .blog-toc__header[hidden] / .blog-toc__list[hidden].
    if (!tocItems.length) {
        $('.blog-toc__header, .blog-toc__list', '[data-toc]').attr('hidden', true);
        return;
    }

    // Scroll spy — highlight the active ToC entry.
    var scrollSpyActive = true;
    var blogHeader = document.querySelector('.blog-header');

    // Where a clicked heading lands: just below the sticky blog header
    // (whose height varies by breakpoint).
    function stickyOffset() {
        var headerBottom = blogHeader ? blogHeader.getBoundingClientRect().bottom : 0;
        return Math.max(0, headerBottom) + 32;
    }

    // Detection line sits a little below the landing point, so a heading that
    // has just scrolled into place still counts as "reached" (avoids the
    // active highlight snapping back to the previous entry on sub-pixel jitter).
    function detectionLine() {
        return stickyOffset() + 16;
    }

    function setActive(id) {
        tocItems.forEach(function (item) {
            item.$link.toggleClass('blog-post__toc-link--active', item.id === id);
        });
    }

    function syncActive() {
        if (!scrollSpyActive) { return; }

        // At (or near) the bottom of the page, force the last entry active —
        // the final sections may never reach the top threshold otherwise.
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
            setActive(tocItems[tocItems.length - 1].id);
            return;
        }

        // Nothing is active until a heading actually crosses the detection
        // line — otherwise the first entry highlights while still above the
        // fold (most obvious when there's a single heading).
        var offset   = detectionLine();
        var activeId = null;
        for (var i = 0; i < tocItems.length; i++) {
            if (tocItems[i].el.getBoundingClientRect().top <= offset) {
                activeId = tocItems[i].id;
            } else {
                break;
            }
        }
        setActive(activeId);
    }

    var spyTicking = false;
    function onSpyScroll() {
        if (!spyTicking) { spyTicking = true; window.requestAnimationFrame(function () {
            spyTicking = false;
            syncActive();
        }); }
    }
    window.addEventListener('scroll', onSpyScroll, { passive: true });
    window.addEventListener('resize', onSpyScroll);
    syncActive();

    // Smooth scroll on ToC click
    $tocList.on('click', 'a', function (e) {
        e.preventDefault();
        var targetId = $(this).attr('href').replace('#', '');
        var $target = $('#' + targetId);

        if ($target.length) {
            $('html, body').stop(true);
            scrollSpyActive = false;

            var top = $target.offset().top - stickyOffset();
            $('html, body').animate({ scrollTop: top }, 300).promise().done(function () {
                window.history.replaceState(null, '', '#' + targetId);
                scrollSpyActive = true;
                syncActive();
            });
        }
    });
}

module.exports = { init };
